export default __webpack_public_path__ + "static/media/kissha.22cbc69c.png";